'use client';

import { Box } from '@/components/layout/box';
import Collection from '@/components/page-components/collection';

export default function RecentlyViewed({ cartStyleType }: { cartStyleType?: 'default' | 'large' }) {
  return (
    <Box>
      <Collection
        key={19}
        {...{
          data: { title: 'Recently Viewed', queryType: 'recent-views', cartStyle: cartStyleType },
          index: 1,
          loaded: false,
          ssr: false,
          type: 'collection',
          id: null,
          publish: true,
          display: { web: true, native: true },
        }}
      />
    </Box>
  );
}

